import React, { useMemo } from 'react'
import injectSheet from 'react-jss'
import styles from './slide.styles'
import Slide from '../../../components/slide/slide.jsx'
import Button from '../../../components/button/button.jsx'
import LinkIcon from '../link-icon.jsx'
import placeholder from 'pobble-components/dist/presentation/link-image-placeholder.svg'
import Heading from '../../../components/heading/heading.jsx'
import ColumnsLayout from '../../../components/columns-layout/columns-layout.jsx'
import { withPresentation } from '../../../presentation-connectors'
import Slidetext from '../../../components/slide-text/slide-text.jsx'

const LinkSlide = ({ classes, slides, id }) => {
  const data = slides[id]

  const slideData = useMemo(
    () => ({
      link: data.link.site_url,
      title: data.title,
      image: data.link.image || placeholder,
      text: data.text || '',
      htmlText: data.html_text || ''
    }),
    [data]
  )

  return (
    <Slide>
      <ColumnsLayout reverse image={slideData.image} alt={slideData.title}>
        <Heading className={classes.title}>{slideData.title}</Heading>
        <Button
          icon={<LinkIcon />}
          className={classes.button}
          target="_blank"
          href={slideData.link}>
          View website
        </Button>
        {!!slideData.htmlText && (
          <Slidetext
            className={classes.description}
            html={slideData.htmlText}
          />
        )}
      </ColumnsLayout>
    </Slide>
  )
}

export default withPresentation(injectSheet(styles)(LinkSlide))
